try {
  class TranscriptForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', (e) => e.preventDefault());

      let formId = this.form.id.replace('__legacy-customer-form', '');
      this.productForm = document.getElementById(formId);

      this.type = this.getAttribute('data-set-type');

      this.submitButton = this.querySelector('button');
      this.submitButton.addEventListener('click', () => this.handleSubmit());
      this.submitButton.disabled = true;

      this.checkout = this.getAttribute('data-checkout');
      if (this.checkout) {
        this.details = document.querySelector('product-details');
        this.transcript = this.details.dataset.transcript;
        this.purchaseTranscript = this.details.querySelector(
          '#ProductDetailsPurchaseTranscript'
        );
      } else {
        let addToBagSelector = this.getAttribute('data-add-to-bag');
        this.addToBag = document.querySelector(addToBagSelector);
        this.allButtons = document.querySelectorAll(
          '.product-form__buttons button'
        );
      }

      this.init();
    }

    init() {
      Array.from(this.form.elements).forEach((element) => {
        if (
          ['input', 'textarea', 'select'].includes(
            element.tagName.toLowerCase()
          )
        ) {
          element.addEventListener('input', () => this.validateForm());
          element.addEventListener('blur', () =>
            this.handleValidation(element)
          );
        }
      });

      const input = this.querySelector('#RegisterForm-DOB');
      if (input) {
        input.addEventListener('input', function (e) {
          var input = e.target.value.replace(/\D/g, '').substring(0, 8);
          var formattedInput = '';

          for (let i = 0; i < input.length; i++) {
            if (i == 2 || i == 4) {
              formattedInput += '/';
            }
            formattedInput += input.charAt(i);
          }

          e.target.value = formattedInput;
        });
      }

      this.initial = this.getAttribute('data-initial');
      if (this.initial === 'true') {
        this.toggleButtons(true);
      }
    }

    purchaseTranscriptHandler(transcriptData) {
      const properties = JSON.stringify({
        course_name: this.details.dataset.product,
        from_section: this.details.dataset.session,
        from_variant_id: this.details.dataset.variantId,
        from_section_id: this.details.dataset.sectionId,
        to_section: this.details.dataset.newSession,
        to_variant_id: this.details.dataset.newVariant,
        to_section_id: this.details.dataset.newSectionId,
        customer: transcriptData,
      });
      console.log('properties',properties)

      return fetch(`https://${Shopify.shop}/api/2025-01/graphql.json`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.storefrontAccessToken,
        },
        body: JSON.stringify({
          query: this.details.getPurchaseQuery(
            'transcript',
            this.transcript,
            properties
          ),
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          window.location = data.data.cartCreate.cart.checkoutUrl;
        });
    }

    handleSubmit() {
      const formData = new FormData(this.form);
      const data = Object.fromEntries(formData.entries());
      const transcriptData = Object.values(data).join('_');

      if (this.checkout) {
        this.purchaseTranscriptHandler(transcriptData);
      } else {
        let inputElement = `<input type="hidden" id="transcript_customer" name="properties[customer]" value="${transcriptData}">`;
        if (
          this.type &&
          document.querySelector('[template="product.credit"]')
        ) {
          inputElement += `<input type="hidden" name="properties[_type]" value="manual_transcript">`;
        }
        this.productForm.insertAdjacentHTML('beforeend', inputElement);

        const modal = this.getAttribute('data-modal-close');

        const modalElement = document.querySelector(modal);
        if (modalElement) {
          modalElement.click();
        }

        this.toggleButtons(false);
      }
    }

    handleValidation(element) {
      this.clearErrorMessage(element);

      if (element.id === 'RegisterForm-DOB') {
        this.validateDOB(element);
      }

      if (!element.checkValidity()) {
        this.showErrorMessage(
          element,
          element.validationMessage ||
            element.dataset.errorMessage ||
            'Invalid input'
        );
      }
    }
    
    validateDOB(element) {
      const value = element.value.trim();

      const match = value.match(
        /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(\d{4})$/
      );

      if (!match) {
        element.setCustomValidity('Date of Birth must be in MM/DD/YYYY format');
        return false;
      }

      const month = parseInt(match[1], 10);
      const day = parseInt(match[2], 10);
      const year = parseInt(match[3], 10);

      const currentYear = new Date().getFullYear();

      if (year < 1900 || year > currentYear) {
        element.setCustomValidity(
          `Birth year must be between 1900 and ${currentYear}`
        );
        return false;
      }

      const dob = new Date(year, month - 1, day);

      if (
        dob.getFullYear() !== year ||
        dob.getMonth() !== month - 1 ||
        dob.getDate() !== day
      ) {
        element.setCustomValidity('Please enter a valid date');
        return false;
      }

      if (dob > new Date()) {
        element.setCustomValidity('Date of Birth cannot be in the future');
        return false;
      }

      element.setCustomValidity('');
      return true;
    }

    toggleButtons(disabled) {
      if (this.allButtons) {
        this.allButtons.forEach((button) => (button.disabled = disabled));
        if (!disabled) {
          if (this.addToBag.querySelector('.button__inner-text')) {
            this.addToBag.querySelector(
              '.button__inner-text'
            ).innerText = `${this.addToBag.getAttribute('data-default')}`;
          } else {
            this.addToBag.innerText = `${this.addToBag.getAttribute(
              'data-default'
            )}`;
          }
        }
      }
    }

    validateForm() {
      let isValid = true;

      Array.from(this.form.elements).forEach((element) => {
        if (element.id === 'RegisterForm-DOB') {
          this.validateDOB(element);
        }

        if (!element.checkValidity()) {
          isValid = false;
        }
      });

      this.submitButton.disabled = !isValid;
    }

    showErrorMessage(element, message) {
      const label = element.labels[0];
      if (label) {
        const errorSpan = document.createElement('span');
        errorSpan.textContent = message;
        errorSpan.className = 'error-message';
        label.appendChild(errorSpan);
      }
    }

    clearErrorMessage(element) {
      const label = element.labels[0];
      if (label) {
        const errorSpan = label.querySelector('.error-message');
        if (errorSpan) {
          errorSpan.parentNode.removeChild(errorSpan);
        }
      }
    }
  }
  customElements.define('transcript-form', TranscriptForm);
} catch (e) {}
